import { type MergedCouponCriterion } from '@cart-services/types'
import { AppliedStatus } from '@hooks-api/types/dataModel/coupon'
import { HStack } from '@pets-ui/HStack/HStack'
import { Star } from '@pets-ui/icons'
import { Paper } from '@pets-ui/Paper/Paper'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { CouponCondition } from '../CouponCondition/CouponCondition'

interface DiscountTipsProps {
  mergedCouponCriterions: MergedCouponCriterion[]
  currency?: string
}

export function DiscountTips({ mergedCouponCriterions, currency }: DiscountTipsProps) {
  return (
    <Paper elevation={0} borderRadius={8}>
      <VStack gap="8px" p="8px">
        <HStack gap={2} width="100%" alignItems="center" justifyContent="space-between">
          <HStack gap={1} alignItems="center">
            <Star color={colors.yellow600} />
            <Text variant="subtitle">優惠活動</Text>
          </HStack>
        </HStack>
        <VStack gap="8px">
          {mergedCouponCriterions?.map((couponCriterion) => {
            const isApplied = couponCriterion.applied_status === AppliedStatus.APPLIED || couponCriterion.applied_status === AppliedStatus.UNABLE
            return (
              <CouponCondition
                key={`${couponCriterion.coupon_id}_${couponCriterion.id}`}
                isApplied={isApplied}
                displayName={couponCriterion.display_name}
                currency={currency}
                moreAmount={couponCriterion.left_amount}
                moreQuantity={couponCriterion.left_quantity ?? couponCriterion.display_criterion_quantity}
                count={couponCriterion.count}
              />
            )
          })}
        </VStack>
      </VStack>
    </Paper>
  )
}
